<template>
  <transition :name="mostrarModal ? 'slide-left' : 'slide-right'" appear>
    <div class="modal">
      <div class="modal-content" :key="mostrarModal">
        <div class="modal-header">
          <h2>Tabela de recarga</h2>
          <span
            style="
              cursor: pointer;
              font-size: 24px;
              position: absolute;
              top: 0px;
              right: 2px;
            "
            @click="fecharModal()"
          >
            <img
              v-if="!isMobile"
              src="../../components/plans/planInfo/Close.svg"
              alt="Fechar"
            />
            <img
              v-else
              src="../../components/plans/planInfo/CloseMobile.svg"
              alt="Fechar"
            />
          </span>
        </div>
        <p class="subTitle">Pessoa Física</p>
        <div class="price-cards">
          <div class="card price-card">
            R$ {{ recarga1.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga1.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga2.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga2.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga3.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga3.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga4.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga4.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga5.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga5.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga6.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga6.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga7.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga7.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga8.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga8.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga9.valor / 100 }}
            <div class="taxValue">Taxa: {{ recarga9.taxa | cents }}</div>
          </div>
          <div class="card price-card">
            R$ {{ recarga10.valor / 100 }}+
            <div class="taxValue">Taxa: {{ recarga10.taxa / 100 / 10 }}%</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import contract from "../../../../../services/contracts";
export default {
  props: {
    numeroContrato: undefined,
    idUsuario: undefined,
  },
  data() {
    return {
      motivo: "",
      errorMessage: undefined,
      errorMessageChargeback: undefined,
      mostrarModal: true,
      isMobile: false,
      recarga1: undefined,
      recarga2: undefined,
      recarga3: undefined,
      recarga4: undefined,
      recarga5: undefined,
      recarga6: undefined,
      recarga7: undefined,
      recarga8: undefined,
      recarga9: undefined,
      recarga10: undefined,
      recarga11: undefined,
    };
  },

  mounted() {
    // saber se está em desktop ou mobile.
    if (window.innerWidth <= 769) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    // evento disparado toda vez que a tela muda de tamanho
    window.addEventListener("resize", () =>
      window.innerWidth <= 769
        ? (this.isMobile = true)
        : (this.isMobile = false)
    );

    contract.getRechargesRoadcard(70).then((res) => {
      this.recarga1 = res.plano.recargas[0];
      this.recarga2 = res.plano.recargas[1];
      this.recarga3 = res.plano.recargas[2];
      this.recarga4 = res.plano.recargas[3];
      this.recarga5 = res.plano.recargas[4];
      this.recarga6 = res.plano.recargas[5];
      this.recarga7 = res.plano.recargas[6];
      this.recarga8 = res.plano.recargas[7];
      this.recarga9 = res.plano.recargas[8];
      this.recarga10 = res.plano.recargas[9];
      this.recarga11 = res.plano.recargas[10];
    });
  },
  methods: {
    fecharModal() {
      this.$emit("fechar-modal");
      this.mostrarModal = false;
    },
  },
};
</script>

<style scoped>
/* //NOTEBOOK */
html,
body {
  overflow-x: hidden;
}
.price-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  margin-left: -3px;
}

.price-card {
  border: 1px solid #e0e0e0;
  font-size: 20px;
  font-family: Inter;
  font-weight: 600;
  line-height: 30px;
  word-wrap: break-word;
  padding: 7px;
  text-align: center;
  border-radius: 10px;
  height: 72px;
  width: 118px;
}

.price-card strong {
  font-weight: bold;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 172px;
  /* width: calc(50% - 136px); */
  position: absolute;
  /* top: 50%; */
  left: 50%;
  width: 410px;
  height: max-content;
  transform: translateX(-50%);
  margin-top: -58px;
}

.modal-content {
  background-color: #fff;
  width: 389px;
  padding: 13px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7f56d9;
  font-size: 36px;
  font-family: Inter;
  font-weight: 600;
  line-height: 44px;
  word-wrap: break-word;
  border: none;
  margin-bottom: -20px;
}

.modal-header h2 {
  margin: 0;
  border-bottom: none;
}

.modal-body label {
  display: block;
  font-weight: bold;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.4s ease-in-out;
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.4s ease-in-out;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.subTitle {
  color: rgba(26, 41, 61, 0.83);
  font-size: 16px;
  font-family: Inter;
  font-weight: 600;
  line-height: 44px;
  word-wrap: break-word;
}
.taxValue {
  color: rgba(27, 43, 65, 0.69);
  font-size: 14px;
  font-family: Inter;
  font-weight: 300;
  line-height: 24px;
  word-wrap: break-word;
}

@media (min-width: 1024px) {
  .modal {
    width: 600px;
  }
  .modal-content {
    width: 461px;
  }

  .price-cards {
    gap: 10px;
    padding: 20px;
    margin-left: -5px;
  }

  .price-card {
    width: 128px;
    font-size: 23px;
  }
}

@media (max-width: 360px) {
  .price-cards {
    margin-left: 0px;
  }
  .price-card {
    margin-left: -2px;
    width: 114px;
    height: 72px;
    font-size: 19px;
  }
  .modal-content {
    width: 374px;
  }
  .taxValue {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// modalRecharges.vue?a34eab44